import { render, staticRenderFns } from "./InvoiceOutbounds.vue?vue&type=template&id=4fcbb348&"
import script from "./InvoiceOutbounds.vue?vue&type=script&lang=js&"
export * from "./InvoiceOutbounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports